var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterProfile = function SvgTwitterProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22A2F2",
    fillRule: "evenodd",
    d: "M14 25.667c6.444 0 11.667-5.224 11.667-11.667S20.444 2.333 14.001 2.333C7.557 2.333 2.334 7.557 2.334 14s5.223 11.667 11.667 11.667zm5.792-15.55a6.509 6.509 0 0 0 1.792-.491 6.213 6.213 0 0 1-1.558 1.614c.006.132.011.264.011.402 0 4.108-3.128 8.848-8.85 8.848a8.75 8.75 0 0 1-4.77-1.396c.245.032.49.043.744.043a6.251 6.251 0 0 0 3.856-1.326 3.14 3.14 0 0 1-2.906-2.166c.189.042.39.053.589.053.286 0 .562-.033.815-.103a3.124 3.124 0 0 1-2.491-3.055v-.034c.415.229.905.374 1.405.383a3.112 3.112 0 0 1-.956-4.155 8.803 8.803 0 0 0 6.41 3.252 3.161 3.161 0 0 1-.073-.71 3.109 3.109 0 0 1 5.379-2.125 6.238 6.238 0 0 0 1.971-.753 3.09 3.09 0 0 1-1.368 1.719z",
    clipRule: "evenodd"
  })));
};
export default SvgTwitterProfile;